import { DevToolsPhoneIcon } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsToggle/DevToolsPhoneIcon';
import type { DevToolsToggleButtonProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsToggle/DevToolsToggleButton/index.types';
import React from 'react';
import { cn } from '~/lib/utils';

/**
 * DevToolsToggleButton - The rail tab that opens the DevTools panel
 *
 * Above the floating softphone, not below it. The softphone popout is draggable
 * and remembered where the user left it — which is usually the bottom right,
 * exactly where this tab lives — so at a lower layer the only way into the
 * panel was to first drag the softphone out of the way. A launcher that can be
 * covered by the thing it inspects is a launcher you cannot reach; overlapping
 * a 100px tab is the smaller cost.
 *
 */
export const DevToolsToggleButton: React.FC<DevToolsToggleButtonProps> = ({
  isOpen,
  onClick,
  className,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'cursor-pointer',
      // z: above the softphone popout (9999) and the panel itself (9998).
      'fixed bottom-30 right-0 z-[10000]',
      'flex items-center justify-center',
      'h-10 w-10 rounded-tl-md rounded-bl-md',
      'shadow-lg',
      'transition-all duration-200',
      'hover:brightness-110 active:scale-95',
      'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-0',
      'bg-primary/15 text-primary border border-primary/25',
      isOpen && 'ring-2 ring-primary/30',
      className
    )}
    aria-label={isOpen ? 'Close DevTools' : 'Open DevTools'}
    title="Softphone DevTools"
  >
    <DevToolsPhoneIcon className="h-4 w-4" />
  </button>
);
